import React from 'react';
import LegalTextPage from '../components/LegalTextPage.jsx';

// The AI transparency page (D-HP-SITE-031): Art. 50 of the AI Act as the company meets it.
const AiTransparencyPage = () => <LegalTextPage pageKey="aiTransparency" pageId="aiTransparency" />;

export default AiTransparencyPage;
